export const fhirSystems = {
  source: {
    system: 'http://lifeomic.com/fhir/source-type',
    values: {
      elationAppointment: 'Elation Appointment',
    },
  },
  questionnaireResponse: {
    notStarted: {
      system:
        'http://lifeomic.com/fhir/questionnaireresponse/survey-not-started',
    },
    type: {
      system: 'http://lifeomic.com/fhir/questionnaire-type',
      values: {
        surveyResponse: 'survey-response',
      },
    },
  },
  appointment: {
    locationType: {
      system:
        'http://lifeomic.com/fhir/fountain-life-appointment-location-type',
      values: {
        inPerson: 'in-person',
        virtual: 'virtual',
      },
    },
    sequence: {
      system: 'http://lifeomic.com/fhir/appointment-sequence',
      values: {
        prerequisite: 'prerequisite',
      },
    },
    elationReason: {
      system: 'http://lifeomic.com/fhir/elation-appointment-reason',
    },
    reason: {
      system: 'http://lifeomic.com/fhir/appointment-reason',
      values: {
        prescreening: 'nurse-prescreening',
        ppc: 'personalized-physician-consult',
        diagnostics: 'precision-diagnostics',
      },
    },
  },
  practitioner: {
    role: {
      system: 'http://lifeomic.com/fhir/fountain-life-practitioner-role',
      values: {
        physician: 'physician',
      },
    },
  },
  membershipTier: {
    system: 'http://lifeomic.com/fhir/fountain-life-membership-tier',
  },
  patient: {
    elationTag: {
      system: 'https://elationemr.com/PatientTag',
    },
  },
  documentReference: {
    fileId: {
      system: `http://lifeomic.com/fhir/file-id`,
    },
    fileOwnershipValidationStatus: {
      system: `http://lifeomic.com/fhir/file-ownership-validation-status`,
      values: {
        pending: 'pending',
        valid: 'valid',
        invalid: 'invalid',
        inconclusive: 'inconclusive',
      },
    },
    manuallyVerifiedFileOwnership: {
      system: `http://lifeomic.com/fhir/manually-verified-file-ownership`,
    },
    fileOwnershipValidationReasoningCode: {
      system: `http://lifeomic.com/fhir/file-ownership-validation-reasoning-code`,
      values: {
        matchedIdentity: 'matched-identity',
        mismatchedIdentity: 'mismatched-identity',
        insufficientData: 'insufficient-data',
        undefined: 'undefined',
        unsupportedFileType: 'unsupported-file-type',
      },
    },
  },
} as const;

export const fhirExtensions = {
  createdDate: {
    url: 'https://lifeomic.com/fhir/createdDate',
  },
};
